var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-sos"},[_c('Header'),_c('p',{staticClass:"title"},[_vm._v("SOS")]),_c('switch-toggle',{model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}}),_c('p',{staticClass:"information"},[_vm._v("Swipe right to call our aid tent.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }